import queryString from 'query-string'
import { connect } from 'react-redux'
import { LOGIN_PATH } from 'data/auth/utils'
import { RootState } from 'duck/store'
import { goToRoute } from 'utils/history'
import { getAccountPageState } from 'scenes/Account/duck/selectors'
import { changePasswordBegin } from 'scenes/Account/duck/actions'

import ResetPasswordForm from './ChangePasswordForm.presentational'

function mapStateToProps(state: RootState) {
  const { isLoading } = getAccountPageState(state)
  const { email, token } = queryString.parse(window.location.search)
  if (!email || !token || email.constructor === Array || token.constructor === Array) {
    goToRoute(LOGIN_PATH)
    return {
      email: '',
      token: '',
      loading: true,
    }
  }
  return {
    email: email as string,
    token: token as string,
    loading: isLoading,
  }
}

export default connect(mapStateToProps, {
  onSubmit: changePasswordBegin,
})(ResetPasswordForm)
